import { render } from "./CustomerOrders.vue?vue&type=template&id=12014794&scoped=true"
import script from "./CustomerOrders.vue?vue&type=script&lang=js"
export * from "./CustomerOrders.vue?vue&type=script&lang=js"

import "./CustomerOrders.vue?vue&type=style&index=0&id=12014794&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12014794"]])

export default __exports__